import { Dispatch } from 'redux';

import { OnboardingStatus } from 'src/entities/OnboardingStatus';
import { improvedOnboardingApi } from 'src/services/api/improvedOnboardingApi';
import { AppThunkAction } from 'src/store';
import { setTrialState } from 'src/store/user/actions';

export const OnboardingTaskStatusHandler =
  (onboardingStatuses: OnboardingStatus): AppThunkAction =>
  async (dispatch: Dispatch<any>, getState) => {
    const stripeSubscriptions = getState().user.data?.stripeSubscriptions;
    dispatch(setTrialState(stripeSubscriptions, onboardingStatuses));

    dispatch(
      improvedOnboardingApi.util.updateQueryData(
        'getOnboardingTaskStatus',
        { subscriptions: stripeSubscriptions },
        (onboardingStatusDraft) => {
          onboardingStatusDraft.fields = onboardingStatuses.fields;
          onboardingStatusDraft.additionalFields =
            onboardingStatuses.additionalFields;
        },
      ),
    );
  };
